<template>
  <el-pagination
    background
    :current-page="currentPage"
    :page-size="pageSize"
    :total="pageTotal"
    :page-sizes="[10, 20, 30, 40, 50]"
    :layout="isPages?'prev, pager, next ,sizes ,jumper':'prev, pager, next ,jumper'"
    @current-change="handleCurrentChange"
    @size-change="handleSizeChange"
    v-if="pageTotal!==0"
  ></el-pagination>
</template>

<script>
export default {
  props: {
    pageTotal: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    isPages: {
      type:Boolean,
      default:function(){
        return false
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    handleSizeChange(val){
      this.$emit("handleSizeChange", val);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pagination/index.vue